import type { HomepageContent } from '../../cms/homepage'
import type { NewsCardItem } from '../../utils/content'
import NewsCard from '../NewsCard'
import HomepageActionLink from './HomepageActionLink'
import HomepageSectionHeader from './HomepageSectionHeader'

type SupportingDiscoveriesSectionProps = {
  content: HomepageContent['supportingDiscoveries']
  items: NewsCardItem[]
}

export default function SupportingDiscoveriesSection({
  content,
  items,
}: SupportingDiscoveriesSectionProps) {
  if (items.length === 0) {
    return null
  }

  return (
    <section className="home-section home-supporting-news">
      <HomepageSectionHeader
        eyebrow={content.eyebrow}
        title={content.title}
        intro={content.body}
        cta={(
          <HomepageActionLink className="button ghost" href={content.ctaHref}>
            {content.ctaLabel}
          </HomepageActionLink>
        )}
      />
      <div className="news-grid">
        {items.map((item) => (
          <NewsCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  )
}
